import { EventRepository } from '../../internal/repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { Event } from '../domain/entities/Event';

export class RemoveItemUseCase {
    private eventRepository: EventRepository;
    private skuId: string;

    constructor(skuId: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.skuId = skuId;
    }

    public execute = async () => {
        const removeItemPayload = {
            event_name: 'remove',
            event_category: 'ecommerce',
            event_action: 'remove from bag',
            enh_action: 'remove'
        };

        const cartProductPayload = {
            skuId: this.skuId
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.REMOVE_ITEM,
            type: 'link',
            payload: removeItemPayload,
            data: {
                cartProduct: cartProductPayload
            }
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
